import { render, staticRenderFns } from "./selectStudents.vue?vue&type=template&id=2383e6fc&scoped=true&"
import script from "./selectStudents.vue?vue&type=script&lang=js&"
export * from "./selectStudents.vue?vue&type=script&lang=js&"
import style0 from "./selectStudents.vue?vue&type=style&index=0&id=2383e6fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2383e6fc",
  null
  
)

export default component.exports